import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useClientTerminology } from '@/views/list/NetworkTerms';
import { InputSelect } from '@/components';
import { useVoltageFormatter } from '@/views/list/Level3Item';
import type { FilterState } from '@/features/filterSlice';

export const VoltageFilter = ({
  control,
  options,
  disabled = false,
}: {
  control: Control<FilterState>;
  options: number[];
  disabled?: boolean;
}) => {
  const intl = useClientTerminology();
  const formatVoltage = useVoltageFormatter();

  // Don't show dropdown if there's only 1 option
  if (options.length <= 1) {
    return null;
  }

  const choices = [...options]
    .sort((a: number, b: number) => a - b)
    .map((e) => ({
      label: formatVoltage(e),
      value: e.toString(),
    }));
  return (
    <Controller
      control={control}
      name={'voltageInKv'}
      render={({ field: { onChange, onBlur, value } }) => {
        return (
          <InputSelect
            isMulti={true}
            label={intl.formatMessage({ id: 'filter.voltageLabel' })}
            placeholder={intl.formatMessage({
              id: 'filter.voltagePlaceholder',
            })}
            options={choices}
            onChange={onChange}
            onBlur={onBlur}
            isDisabled={disabled}
            value={choices.filter((c) => value.includes(c.value))}
          />
        );
      }}
    />
  );
};
